<template>
    <ul v-if="loaded" :class="[{'file-tree': typeof collections === 'string'}, 'collection-group']">
        <li :class="typeof collections === 'string' ? 'parent-node' : 'tree-node'" v-for="collection in collectionTree" :key="collection.id">
            <span :class="['folder', {'empty-collection': !collection.children.length}, {'collapsible': collection.children.length}]" @click="collapse(collection)">
                <i v-if="!collection.children.length && !collection.metadata.length" class="far fa-folder"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection doesn't have sub-collections and metadata" />
                <i v-else-if="!collection.children.length && collection.metadata.length" class="fas fa-folder"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection has metadata" />
                <i v-else-if="collection.children.length && !collection.metadata.length && !collection.isExpanded" class="fas fa-folders"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection has sub-collections"  />
                <i v-else-if="collection.children.length && !collection.metadata.length && collection.isExpanded" class="fas fa-folder-open"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection has sub-collections"  />
                <i v-else-if="!collection.isExpanded" class="fad fa-folders"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection has sub-collections and metadata" />
                <i v-else class="fad fa-folder-open"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="This collection has sub-collections and metadata" />
            </span>
            <span v-if="!collection.isSelected">
                <a :href="getCollectionUrl(collection.id)">{{ collection.title }}</a>
            </span>
            <span v-else>
                {{ collection.title }}
            </span>
            <span v-if="collection.children.length && collection.isExpanded">
                <collection
                    :collections="collection.children"
                    :selected-collection="selectedCollection"
                    :collection-url="collectionUrl"
                />
            </span>
        </li>
        <div v-if="!collectionTree.length">
            There's no collection in this organisation.
        </div>
    </ul>
    <Loading v-else />
</template>

<script>
/**
   * This is the collection component used in 'collection_detail_view' and 'collection_list_view'
*/
import Loading from 'src/components/Loading.vue'

export default {
    name: "collection",
    components: {
        Loading
    },
    props: {
        // A list of collections which are visible to users (determined by parent's and root's visibility), if it's empty, the user is visible to all collections
        visibleCollections: {
            type: String,
            default: ''
        },
        // All visible collections passed from django, or passed from parent collection
        collections: {
            type: [String, Array],
            required: true,
        },
        // The absolute url of collection
        collectionUrl: {
            type: String,
            required: true,
        },
        // The selected collection in this page, if it's detail view
        selectedCollection: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        collectionTree: {},
        visibleCollection: [],
        loaded: false,
    }),
    created: function() {
        this.initializeTree()
    },
    methods: {
        initializeTree: function() {
            if (typeof this.collections === 'string') {
                this.visibleCollection = JSON.parse(this.visibleCollections)
                let collectionArray = JSON.parse(this.collections)
                this.collectionTree = this.normalizeTreeArray(collectionArray)
            } else {
                this.collectionTree = this.collections
            }
            this.loaded = true
        },
        // Process raw data into tree and items structures
        normalizeTreeArray: function(items) {
            let components = []
            let visibleItems = this.visibleCollection.length ? items.filter(i => this.visibleCollection.indexOf(i.id)!=-1) : items
            for (const item of visibleItems) {
                let treeItem = {
                    id: item.id,
                    title: item.name,
                    metadata: item.metadata,
                    isExpanded: false,
                    isSelected: false,
                }
                if (this.selectedCollection && item.id == Number(this.selectedCollection)) {
                    treeItem.isExpanded = true
                    treeItem.isSelected = true
                }
                let ancestors = [treeItem]
                treeItem.children = this.splitData(item.collections, components, ancestors)
                components.push(treeItem)
            }
            return components
        },
        // Process sub collections into tree and items structures
        splitData: function(data, components, ancestors) {
            let tree = []
            let visibleItems = this.visibleCollection.length ? data.filter(i => this.visibleCollection.indexOf(i.id) != -1) : data
            for (const item of visibleItems) {
                let treeItem = {
                    id: item.id,
                    title: item.name,
                    metadata: item.metadata,
                    isExpanded: false,
                    isSelected: false,
                }
                // Expand parent collection, if the child collection is selected
                let newAncestor = []
                if (this.selectedCollection && item.id == Number(this.selectedCollection)) {
                    ancestors.forEach(element => {
                        element.isExpanded = true
                    })
                    treeItem.isSelected = true
                    treeItem.isExpanded = true
                } else if (ancestors.length) {
                    newAncestor = [...ancestors, ...[treeItem]]
                }
                treeItem.children = this.splitData(item.collections, components, newAncestor)
                tree.push(treeItem)
            }
            return tree
        },
        getCollectionUrl: function(id) {
            return this.collectionUrl.replace(0, id)
        },
        collapse: function(collection) {
            collection.isExpanded = !collection.isExpanded
        }
    }
}
</script>
